import { ButtonMedium } from '@components/core-ui/form-elements/buttons/Button/variations/PrimaryButtonSizes';
import { Input } from '@components/core-ui/form-elements/Input';
import React from 'react';
import { usePageContext } from '../../../../providers/PageProvider';
import { StyledSelect } from '../../styles/StyledSelect';

export const RegistrationPageSurveyStage = () => {
  const {
    setStage,
    howDidYouHearAboutUs,
    setHowDidYouHearAboutUs,
    howDidYouHearAboutUsReferral,
    setHowDidYouHearAboutUsReferral,
    howDidYouHearAboutUsComment,
    setHowDidYouHearAboutUsComment,
    goToLogin,
  } = usePageContext();

  const isCommentRequired = howDidYouHearAboutUs === 'Other';
  const isButtonDisabled =
    !howDidYouHearAboutUs?.length ||
    (howDidYouHearAboutUs === 'Referral' && !howDidYouHearAboutUsReferral?.length) ||
    (howDidYouHearAboutUs === 'Other' && !howDidYouHearAboutUsComment?.length);

  const handleFormSubmit = async (evt: React.FormEvent) => {
    evt.preventDefault();
    setStage('signupPhone');
  };

  const howDidYouHearOptions = [
    { value: 'Social Media', label: 'Social Media' },
    { value: 'Google/Search Engine', label: 'Google/Search Engine' },
    { value: 'TCRA', label: 'TCRA' },
    { value: 'Word of mouth', label: 'Word of mouth' },
    { value: 'Referral', label: 'Referral' },
    { value: 'Other', label: 'Other' },
  ];

  return (
    <div className="root">
      <h1 className="header">How Did You Hear About Us?</h1>

      <form onSubmit={handleFormSubmit}>
        <div className="margin20">
          <StyledSelect
            name="howDidYouHearAboutUs"
            label="Select from this list..."
            value={howDidYouHearAboutUs ?? ''}
            onChange={(_name, value) => {
              setHowDidYouHearAboutUs(value);
            }}
            options={howDidYouHearOptions}
            required={true}
            hideSelectedOption={false}
          />
        </div>

        {howDidYouHearAboutUs && howDidYouHearAboutUs === 'Referral' ? (
          <div className="margin20">
            <Input
              onChange={(e) => {
                setHowDidYouHearAboutUsReferral(e.target.value);
              }}
              name="howDidYouHearAboutUsReferral"
              label="Referral"
              value={howDidYouHearAboutUsReferral || ''}
              required={true}
            />
          </div>
        ) : null}

        <div className="margin20">
          <Input
            onChange={(e) => {
              setHowDidYouHearAboutUsComment(e.target.value);
            }}
            name="howDidYouHearAboutUsComment"
            label="Leave a comment"
            value={howDidYouHearAboutUsComment || ''}
            required={isCommentRequired}
          />
        </div>

        <ButtonMedium disabled={isButtonDisabled} className="mb-[30px] mx-auto w-full" type="submit">
          Next
        </ButtonMedium>
      </form>

      <p className="haveAnAccount">
        Have an account?&nbsp;&nbsp;
        <span onClick={goToLogin} className="signIn">
          Sign In
        </span>
      </p>
    </div>
  );
};
